<template>
  <div class="container">
    <div class="row g-4">
      <div class="col-lg-12">
        <hero-section :hero-banner="heroBanner" />
        <featured-categories />
        <shop-by-concern />
        <product-categories :productList="productList" :isLoading="isLoading" />
        <promotion-banner :banners="weekendDealBanner" />
        <deals-slider :deals-list="dealsProducts" />
        <promotion-banner :isSingleBanner="true" :banners="fullWidthBanner" />
        <product-grid-section
          :productList="productGridItems"
          :isLoading="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import axios from "axios";
import { BASE_URL } from "@/globals";
import HeroSection from "@/components/HeroSection.vue";
import PromotionBanner from "./PromotionBanner.vue";
import DealsSlider from "./DealsSlider.vue";
import ProductGridSection from "./ProductGridSection.vue";
import ShopByConcern from "./ShopByConcern.vue";
import FeaturedCategories from "./FeaturedCategories.vue";

export default {
  name: "MainBody",
  components: {
    HeroSection,
    ProductCategories: defineAsyncComponent(() =>
      import("@/components/ProductCategories.vue")
    ),
    PromotionBanner,
    DealsSlider,
    ProductGridSection,
    ShopByConcern,
    FeaturedCategories,
  },
  data() {
    return {
      productList: [],
      dealsProducts: [],
      productGridItems: [],
      isLoading: false,
      heroBanner: [],
      weekendDealBanner: [],
      fullWidthBanner: [],
    };
  },
  mounted() {
    this.fetchPreviewProducts();
  },
  methods: {
    async fetchPreviewProducts() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          `${BASE_URL}/api/products/preview/home`
        );
        if (response.data && Object.keys(response.data).length) {
          this.productList = response.data;
          this.dealsProducts = response.data.deals || [];
          this.productGridItems = response.data.productGrid || [];
          this.heroBanner = response.data.homeBanners?.hero || [];
          this.weekendDealBanner = response.data.homeBanners?.weekendDeal || [];
          this.fullWidthBanner = response.data.homeBanners?.fullWidth || [];
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

